import styles from './App.css';
import MyComponent from './config/MyComponent.js';
import Join from './pages/Join';
import Create from './pages/Create';
import Calender from './pages/Calender';
import Sync from './pages/Sync';

import { Route, Routes } from 'react-router-dom';

import React from 'react';
import { useEffect, useState } from 'react';
import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

/**
 * App is the root component of the frontend
 * - It fetches data from the backend on mount
 * - It renders the main navbar and Routes of the frontend
 */
function App() {
  const [message, setMessage] = useState('');

  useEffect(() => {
    axios.get(`${baseURL}/hello`)
      .then(res => {
        setMessage(res.data); 
      })
      .catch(error => {
        console.error('error fetching data: ', error);
      });
  }, []);

  console.log(message);

  return (
    <>
      <Routes>
        <Route path="/" element={<Join />} />
        <Route path="/join" element={<Join />} />
        <Route path="/create" element={<Create />} />
        <Route path="/calender" element={<Calender />} />
        <Route path="/sync" element={<Sync />} />
      </Routes>
    </>
  );
}

export default App;
